module.exports = __webpack_public_path__ + "img/a1-mo.5a2efce7.jpg";